import rootReducer from "@/modules";
import { loadState } from "@/localStorage";
import { createBrowserHistory } from "history";
import { configureStore } from "@reduxjs/toolkit";
import { locationChanged } from "@/modules/router/routerSlice";
import { rejectionNotificationMiddleware } from "./rejectionNotificationMiddleware";
import { useDispatch, useSelector } from "react-redux";

export const history = createBrowserHistory();

const persistedState = loadState();

const store = configureStore({
  reducer: rootReducer,
  preloadedState: persistedState as any, // PersistedState is a partial state from localStorage
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(rejectionNotificationMiddleware),
});

// Initial sync of history to redux
store.dispatch(
  locationChanged({ location: history.location, navAction: history.action }),
);

// Listen to history changes and update redux router slice
history.listen((location, navAction) => {
  store.dispatch(locationChanged({ location, navAction }));
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Use throughout your app instead of plain `useDispatch` and `useSelector`
// React-Redux v9+ provides improved TypeScript support with createDispatchHook
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();

export default store;
